import { AspectRatio } from '@mui/joy';
import { Box, Card, CardContent, Container } from '@mui/material';
import { useLocalStorage } from '@uidotdev/usehooks';
import * as date from 'date-fns';
import { useState } from 'react';
import { RouteObject } from 'react-router-dom';
import useSWR from 'swr';
import { PageSpinner, Video } from '~/components';
import { ChartCard } from '~/components/ChartCard';
import { PageHeader } from '~/components/PageHeader';
import { useFarm } from '~/hooks/useFarm';
// import { applyStandardDeviation1SD,applyStandardDeviationpoint5SD } from '~/utils/stddev';

export const drinkerRoute: RouteObject = {
  path: '/drinker',
  element: <Drinker />,
}

const defaultFrom = date.subWeeks(new Date(), 6)
const defaultTo = date.addDays(new Date(), 1)

function Drinker() {
  const { farm, isLoading: isLoadingFarm, accessStartDate } = useFarm()

  const [from, setFrom] = useLocalStorage('settings.from', date.formatISO(defaultFrom, { representation: 'date' }))
  const [to, setTo] = useLocalStorage('settings.to', date.formatISO(defaultTo, { representation: 'date' }))
  const [params, setParams] = useState({ from, to })

  const { data: drinkerData = [], isLoading } = useSWR(
    `/farms/${farm?.id}/insights/drinker?dateFrom=${params.from}&dateTo=${params.to}`)

  const { data: media } = useSWR(
    `/farms/${farm?.id}/media/drinker/${params.to.replace(/-/g, '')}`)

  const AGE_INVALID = Number.MAX_SAFE_INTEGER;

  const birdCount = drinkerData.map((d: any) => {
    return {
      datetime: date.addHours(date.parseISO(d.date), d.hour),
      date: d.date,
      hour: d.hour,
      avg: d.birdCountAvg,
      age: AGE_INVALID,
      pastavg: null,
      stddev: null,
      stddevp5: null
      // stddev: applyStandardDeviation1SD(d.birdCountAvg, d.birdCountStdDev),
    }
  })

  const inDrinker = drinkerData.map((d: any) => {
    return {
      datetime: date.addHours(date.parseISO(d.date), d.hour),
      date: d.date,
      hour: d.hour,
      avg: d.inDrinkerAvg,
      age: AGE_INVALID,
      pastavg: null,
      stddev: null,
      stddevp5: null
    }
  })

  const percentageDrinking = drinkerData.map((d: any) => {
    return {
      datetime: date.addHours(date.parseISO(d.date), d.hour),
      date: d.date,
      hour: d.hour,
      avg: d.percentageDrinkingAvg,
      age: AGE_INVALID,
      pastavg: null,
      stddev: null,
      stddevp5: null
    }
  })

  const handleApply = () => {
    setParams({ from, to })
  }

  return (
    <Container maxWidth={false} sx={{ pb: '24px' }}>
      <PageHeader title="Drinker" from={from} to={to} setFrom={setFrom} setTo={setTo} handleApply={handleApply} />
      {(isLoadingFarm || isLoading) && <PageSpinner />}
      {!isLoadingFarm && !isLoading  && (
        <Box display={"grid"} gridTemplateColumns={"repeat(auto-fill, minmax(500px, 1fr))"} gap={2}>
          {media?.url && <Video height={'375px'} width='100%' src={media.url} />}
          <ChartCard title="Bird count" data={birdCount} />
          <ChartCard title="In drinker" data={inDrinker} />
          <ChartCard title="% drinking" data={percentageDrinking} />
        </Box>
      )}
    </Container>
  )
}
